import { ProductType, ActiveFilters, ProductColourType } from '../types'

export const getProductColour = (
  product: ProductType,
  activeFilters: ActiveFilters,
  onSale: boolean
): ProductColourType => {
  let colour = null
  const productColours = product.colours
  const colourIDs = Object.keys(productColours)

  // All active colour filters
  const activeColours = activeFilters.colour

  // If no colour filters
  if (!activeColours.size) {
    // set colour price to stupidly high so the first one is always lower (I dont feel good about this either!)
    let cheapestPrice = 9999999

    // if on sale get cheapest sale price
    if (onSale) {
      for (let i = 0; i < colourIDs.length; i++) {
        const currentID = colourIDs[i]
        const currentColour = productColours[currentID]
        if (
          parseFloat(currentColour.sale_price) &&
          parseFloat(currentColour.sale_price) < cheapestPrice
        ) {
          cheapestPrice = parseFloat(currentColour.sale_price)
          colour = currentColour
        }
      }
    }

    // if no colours have a sale price get the colour with the cheapest standard price
    if (colour === null) {
      for (let i = 0; i < colourIDs.length; i++) {
        const currentID = colourIDs[i]
        const currentColour = productColours[currentID]
        if (parseFloat(currentColour.price) < cheapestPrice) {
          cheapestPrice = parseFloat(currentColour.price)
          colour = currentColour
        }
      }
    }
  } else {
    // get all
    const colourList = []
    for (let i = 0; i < colourIDs.length; i++) {
      const id = colourIDs[i]
      const colourTitle = productColours[id].title
      if (activeColours.has(colourTitle)) {
        colourList.push(productColours[id])
      }
    }

    // set colour price to stupidly high so the first one is always lower (I dont feel good about this either!)
    let cheapestPrice = 9999999

    // if on sale get cheapest sale price
    if (onSale) {
      for (let j = 0; j < colourList.length; j++) {
        const currentColour = colourList[j]
        if (
          parseFloat(currentColour.sale_price) &&
          parseFloat(currentColour.sale_price) < cheapestPrice
        ) {
          cheapestPrice = currentColour.sale_price
          colour = currentColour
        }
      }
    }

    // if no colours have a sale price get the colour with the lowest standard price
    if (colour === null) {
      for (let k = 0; k < colourList.length; k++) {
        const currentColour = colourList[k]
        if (parseFloat(currentColour.price) < cheapestPrice) {
          cheapestPrice = currentColour.price
          colour = currentColour
        }
      }
    }
  }

  return colour
}
